import React from "react"
import { RetrospectivaContextProvider } from "./context/RetrospectivaContext"
import ResultadosAnual from "./ResultadosAnual"

export function Index() {
    return (
        <RetrospectivaContextProvider>
            <ResultadosAnual />
        </RetrospectivaContextProvider>
    )
}

export default Index
